<template>
    <div>
        <CModal title="Chọn bản tin" :show.sync="isShow" size="xl" :closeOnBackdrop="false">
            <CRow class="content-fade-in">
                <CCol md="12">
                    <CForm class="form-basic">
                        <CRow>
                            <CCol xs="12" sm="4" md="4" lg="4" xl="4">
                                <div class="form-group">
                                    <label for="datepicker">Từ ngày - đến ngày</label>
                                    <DatePicker id="datepicker" v-model="dateRange"
                                        :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range
                                        class="datepicker">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <input :value="inputValue.start + ' - ' + inputValue.end"
                                                v-on="inputEvents.start"
                                                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                                                readonly />
                                        </template>
                                    </DatePicker>
                                </div>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12" md="12" xl="12">
                                <BaseTable :options="mainTable.options" :slots="mainTable.slots"
                                    :dataSource="mainTable.dataSource" ref="mainTable">
                                    <template #index="{ index }">
                                        <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
                                    </template>

                                    <template #createDate="{ item }">
                                        <td v-if="item.createDate != null">
                                            {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
                                        </td>
                                        <td v-else></td>
                                    </template>
                                    <template #description="{ item }">
                                        <td>
                                            <span :key="item.description" class="description"
                                                v-c-tooltip.hover="item.description">{{
                                                item.description
                                                }}</span>
                                        </td>
                                    </template>
                                    <template #type="{ item }">
                                        <td>
                                            <span class="badge badge-light"
                                                v-if="item.type == 0 && item.isRun == true">Văn bản - Chữ chạy</span>
                                            <span class="badge badge-light"
                                                v-else-if="item.type == 0 && item.isRun == false">Văn bản - Thông
                                                báo</span>
                                            <span class="badge badge-light" v-else-if="item.type == 1">Hình ảnh</span>
                                            <span class="badge badge-light" v-else-if="item.type == 2">Video</span>
                                            <span class="badge badge-light" v-else-if="item.type == 3">RSS</span>
                                            <span class="badge badge-light" v-else-if="item.type == 4">Tài liệu / {{
                                            item.url.substring(item.url.lastIndexOf(".") + 1, item.url.length)
                                            }}</span>
                                            <span class="badge badge-light" v-else-if="item.type == 5">Kênh trực
                                                tuyến</span>
                                        </td>
                                    </template>
                                    <template #checked="{ item }">
                                        <td class="group-checkbox">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" :value="item"
                                                    v-model="listFileSelected"
                                                    :id="item.id" v-c-tooltip.hover="'Chọn bản tin'" />
                                                <label class="custom-control-label" :for="item.id"></label>
                                            </div>
                                        </td>
                                    </template>
                                </BaseTable>
                            </CCol>
                        </CRow>
                    </CForm>
                </CCol>
            </CRow>
            <template v-slot:footer>
                <div slot="footer">
                    <button type="button" class="btn btn-secondary" @click="isShow = false"
                        :disabled="loadingPopup.value">
                        <i class="fa fa-close"></i> Hủy bỏ
                    </button>&nbsp;
                    <button type="button" class="btn btn-primary" @click="submitPopup()" :disabled="loadingPopup.value">
                        <i class="fa fa-save"></i> Chọn
                    </button>
                </div>
            </template>
            <BaseLoading :loading="loadingPopup.value"></BaseLoading>
        </CModal>
    </div>
</template>

<script>

import BaseLoading from "../base/BaseFormLoading";
import BaseTable from "@/views/base/BaseDataTable";
import { DatePicker } from "v-calendar";

export default {
    name: "ChooseFilePopup",
    components: { BaseLoading, BaseTable, DatePicker },
    props: ["type"],
    data() {
        let that = this;
        return {
            isShow: true,
            items: [],
            loadingPopup: { value: false },
            listFileSelected: [],
            dateRange: {
                start: that.$helper.subtractNowDate(30).setHours(0, 0, 0, 0),
                end: new Date().setHours(23, 59, 59, 999)
            },
            dateRangeConfig: {
                start: {
                    timeAdjust: '00:00:00',
                },
                end: {
                    timeAdjust: '23:59:59',
                },
            },
            // typeFile: "",
            mainTable: {
                options: {
                    fields: [
                        { key: "index", label: "STT", sorter: false, filter: false },
                        { key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%" },
                        { key: "title", label: "Tiêu đề" },
                        { key: "description", label: "Mô tả", sorter: false, filter: false },
                        // { key: "url", label: "Nội dung bản tin", sorter: false, filter: false },
                        { key: "duration", label: "Thời lượng phát" },
                        { key: "type", label: "Loại bản tin" },
                        { key: "checked", label: "Chọn" }

                    ],
                    slots: [
                        "index",
                        "createDate",
                        // "url",
                        "type",
                        "description",
                        "checked"
                    ],
                    pageSize: 5,
                    sorter: true,
                    columnFilter: false,
                    tableFilter: false,
                    lazyLoad: false
                },
                dataSource: {
                    url: "/screen-file/getPages",
                    dataSubmit: function () {
                        var params = {
                            type: that.type,
                            fromDate: that.$helper.formatDateDDMMYYYY(that.dateRange.start),
                            toDate: that.$helper.formatDateDDMMYYYY(that.dateRange.end)
                        };
                        if (params.type == -1) {
                            params.type = 0;
                            params.run = true;
                        } else if (params.type == 0) {
                            params.run = false;
                        }
                        return params;
                    },
                    response: function (dataResponse) {
                        return dataResponse.data;
                    },
                },
            },
        }
    },
    methods: {
        submitPopup: function () {
            let that = this;
            var files = [];
            for (var i = 0; i < that.listFileSelected.length; i++) {
                files.push({
                    name: that.listFileSelected[i].title,
                    fileId: that.listFileSelected[i].id,
                    duration: that.listFileSelected[i].duration,
                    content: that.listFileSelected[i].content,
                    url: that.listFileSelected[i].url,
                });
            }
            that.items = that.items.concat(files);
            that.$emit("updateSelectedFiles", that.items);
            that.isShow = false;
            that.$emit("updateIsShowChooseFilePopup", that.isShow);
        },
        loadDataMainTable: function (isUpdateFilter) {
            this.$refs.mainTable.loadData(true, isUpdateFilter);
        },
    },
    mounted() {
        this.loadDataMainTable();
    },
    watch: {
        'isShow': function (value) {
            // let that = this;
            // that.listFileSelected = [];
            // if (value == true) {
            //     that.loadDataMainTable();
            // }
            if (!value){
                this.$emit("updateIsShowChooseFilePopup", value);
            }
        },
        dateRange: function (newValue) {
            if (newValue) {
                this.loadDataMainTable();
            } else {
                this.dateRange = {
                    start: this.$helper.subtractNowDate(30).setHours(0, 0, 0, 0),
                    end: new Date().setHours(23, 59, 59, 999)
                }
            }
        },
        // 'type': function (value) {
        //     if(value) {
        //         this.typeFile = value;
        //         this.$refs.mainTable.loadData(true);
        //     }
        // }
    }
}
</script>
